import styled from 'styled-components';

export default styled.div`
  font-weight: 700;
  text-align: center;
  margin: 15px 0 0;
`;



// WEBPACK FOOTER //
// ./src/components/Skill/PDFDownload.js